module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout',
          to: {
            path: '/tryouts'
          }
        },
        {
          text: 'Rating dan Feedback Tryout'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n                    Rating dan Feedback Tryout\n                ")])])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Rating dan Feedback Tryout ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.data,
      "headers": _vm.headers,
      "has-action": false,
      "has-export": true,
      "has-duplicate": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "exportClicked": function($event) {
        return _vm.exportTryout()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key],
        };
        _vm.doSearch();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36de9c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout_report/components/TryoutRating.vue
// module id = 2132
// module chunks = 1